(ns frontend.test.filter.event)

(def test-fields
  [[:common/disabled?]
   [:oppo/cur-ticket--sym]
   [:oppo/cur-ticket]
   [:task/due]
   [:common/created-on]
   [:account/email]
   [:email/cc]
   [:company/financials]
   [:db/id]
   [:company/number-of-employees]
   [:lp-report/step]
   [:account/additional-responsibilities]
   [:holding/gross-multiple]
   [:company/projected-ftes-moving-in]
   [:fund/carried-interest]
   [:oppo/tag-sector]
   [:oppo/target-asset]
   [:oppo/name]
   [:company/website]
   [:note-call/message]])
